import React, { useEffect, useState } from "react";
import axios from "axios";
import { Outlet, useParams, useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../auth";
import BottomNav from "../components/BottomNav";
import FloatingChatButton from "../components/FloatingChatButton";
import { TCMLogo } from "../components/TCMLogo";

export const TripCtx = React.createContext(null);

export default function TripLayout() {
  const { tripId } = useParams();
  const { API, authHeaders } = useAuth();
  const [trip, setTrip] = useState(null);
  const [updates, setUpdates] = useState([]);
  const nav = useNavigate();
  const location = useLocation();
  const onToday = location.pathname === `/trips/${tripId}` || location.pathname === `/trips/${tripId}/`;

  useEffect(() => {
    axios.get(`${API}/trips/${tripId}`, { headers: authHeaders }).then((r) => setTrip(r.data)).catch(() => nav("/trips"));
    axios.get(`${API}/trips/${tripId}/updates`, { headers: authHeaders }).then((r) => setUpdates(r.data)).catch(() => {});
  }, [tripId]);

  if (!trip) return <div className="p-10 tcm-eyebrow">Loading...</div>;
  const latest = updates[0];

  return (
    <TripCtx.Provider value={{ trip, updates, refresh: () => {
      axios.get(`${API}/trips/${tripId}`, { headers: authHeaders }).then((r) => setTrip(r.data));
    }}}>
      <div className="min-h-screen pb-28" data-testid="trip-layout">
        <header className="px-6 pt-5 pb-3 max-w-3xl mx-auto flex justify-between items-center gap-3">
          <Link to="/trips" data-testid="trip-header-logo" className="flex items-center gap-3 shrink-0" aria-label="My trips">
            <TCMLogo size="sm" />
          </Link>
          <div className="flex items-center gap-3 min-w-0">
            <p className="tcm-eyebrow truncate max-w-[160px] sm:max-w-none">{trip.destination}</p>
            <Link to="/trips" className="tcm-eyebrow underline decoration-[#C9A961] underline-offset-4 whitespace-nowrap" data-testid="back-my-trips">All trips</Link>
          </div>
        </header>
        {latest && !onToday && (
          <div className="px-6 max-w-3xl mx-auto mb-4" data-testid="live-update-banner">
            <div className="border border-[color:var(--tcm-gold)] p-4 flex gap-3 items-start">
              <div className="w-2 h-2 rounded-full bg-[color:var(--tcm-gold)] mt-2 flex-shrink-0" />
              <div>
                <p className="tcm-eyebrow" style={{color: "var(--tcm-gold-700)"}}>Latest update</p>
                <p className="font-display text-xl mt-1">{latest.title}</p>
                <p className="text-sm mt-1 text-[color:var(--tcm-navy-70)]">{latest.body}</p>
              </div>
            </div>
          </div>
        )}
        <main className={onToday ? "max-w-3xl mx-auto" : "px-6 max-w-3xl mx-auto"}><Outlet /></main>
        <FloatingChatButton />
        <BottomNav />
      </div>
    </TripCtx.Provider>
  );
}
